import React from "react";
import InjectHtml from "theme/components/atoms/InjectHtml";

const EmbedPre = (props) => {
  const html = props.children[0].props.children || null;

  if (!html) {
    return null;
  }

  return <InjectHtml data-demo="PrismicWysiwyg / Preformatted" html={html} />;
};

export default EmbedPre;
